"use strict";exports.__esModule = true;var isDescendant = function isDescendant(parent, child) {
  var node = child.parentNode;
  while (node !== null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};exports.default =

isDescendant;module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/utils/isDescendant.js
// module id = 235
// module chunks = 0